import promise from 'promise';
import api from 'app/shared/utils/api';

import appLogger from 'app/shared/loggers/appLogger';

const TermsAndConditionsActions = {
    markAcceptedTerms() {
        return (dispatch) => {
            const params = {
                authZone: null,
                userId: null,
                termsAndConditions: [{
                    type: 'termsAcceptedZillowRentalUser',
                    version: 0,
                }],
            };

            return dispatch(api.users.termsAndConditions.markAcceptedTerms(params))
                .then((response) => {
                    if (response && response.success === false) {
                        return promise.reject(response.error);
                    }

                    return response;
                })
                .catch((errorRMWModel) => {
                    appLogger.logError({
                        message: errorRMWModel.message,
                        context: 'TermsAndConditionsActions.markAcceptedTerms',
                    });
                });
        };
    },
};

export default TermsAndConditionsActions;
